import React, { useState, useEffect } from 'react';
import { getBlockedSlots } from '../../../../api/v2/calls';
import AvailabilityPicker from '../../../phone_calls/availability_picker';

const ScheduleCallModal = ({
  open,
  conversationId,
  otherUserTimezone,
  viewerTimezone,
  otherUserFirstName,
  otherUserName,
  otherUserPhoto,
  incentive = null,
  onClose,
  onCallCreated,
}) => {
  const [blockedSlots, setBlockedSlots] = useState([]);

  useEffect(() => {
    if (!open || !conversationId) return;
    getBlockedSlots(conversationId)
      .then((data) => setBlockedSlots(data.blocked_slots || []))
      .catch(() => setBlockedSlots([]));
  }, [open, conversationId]);

  if (!open) return null;

  const handleCallCreated = (call) => {
    onClose();
    if (typeof onCallCreated === 'function') onCallCreated(call);
  };

  return (
    <AvailabilityPicker
      mentorTimezone={otherUserTimezone}
      viewerTimezone={viewerTimezone}
      mentorFirstName={otherUserFirstName}
      otherUserName={otherUserName}
      otherUserPhoto={otherUserPhoto}
      conversationId={conversationId}
      blockedSlots={blockedSlots}
      incentive={incentive}
      onClose={onClose}
      onCallCreated={handleCallCreated}
    />
  );
};

export default ScheduleCallModal;
